"use strict";

exports.__esModule = true;
exports.ReportDataProvider = ReportDataProvider;
var _react = _interopRequireDefault(require("react"));
var _UhOh = require("../../Core/UhOh");
var _DeviceDetailsReportDataProvider = require("./DeviceDetailsReportDataProvider");
var _StandardReportDataProvider = require("./StandardReportDataProvider");
var _excluded = ["report", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ReportDataProvider(props) {
  var report = props.report,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  if (!(report != null && report.element)) {
    return /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
      error: new Error("Report payload is missing element configuration"),
      title: "Invalid Report",
      description: "The report data is empty or malformed, so this screen cannot be rendered."
    });
  }
  if (report.element.type === "DeviceDetails") {
    return /*#__PURE__*/_react["default"].createElement(_DeviceDetailsReportDataProvider.DeviceDetailsReportDataProvider, _extends({}, others, {
      config: report,
      timeRangeKind: report.element.props ? report.element.props.timeRangeKind : "singleDay"
    }), children);
  }
  return /*#__PURE__*/_react["default"].createElement(_StandardReportDataProvider.StandardReportDataProvider, _extends({}, others, {
    timeRangeKind: report.element.props ? report.element.props.timeRangeKind : "singleDay"
  }), children);
}